import React, { useRef, useEffect, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import { Row, Col, Collapse, Spin, Icon, Select } from 'antd';
import {
  StyledDemonstration,
  StyledCenterItem
} from '../../styled-components/product/product-demonstration';
import UploadImg2base64 from './UploadImg2base64';
import CanvasDrawer from './CanvasDrawer/CanvasDrawer';

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const { Panel } = Collapse;
const { Option } = Select;
const ReactJson = dynamic(import('react-json-view'), { ssr: false });

const FunctionDemonstration = ({
  response,
  request,
  result,
  materialsPath = [],
  selectList = [],
  handleIdentifyingImg,
  noUpload
}) => {
  const imgRef = useRef(null);
  const [spinning, setSpinning] = useState(false);
  const [imgDom, setImgDom] = useState(null);
  const [activeSelectIndex, setActiveSelectIndex] = useState(0);
  const [activeSelectParam, setActiveSelectParam] = useState(0);

  const identifyingImg = useCallback(
    (e, imgurl, activeIndex, param) => {
      setActiveSelectIndex(activeIndex === undefined ? '-1' : activeIndex);
      setSpinning(true);
      if (e && e.preventDefault) {
        e.preventDefault();
      }
      const Dom = document.createElement('IMG');
      Dom.setAttribute('crossOrigin', 'anonymous');
      Dom.onload = () => {
        setImgDom(Dom);
      };
      Dom.src = imgurl;
      if (e) {
        handleIdentifyingImg(imgurl, null, param);
      } else {
        handleIdentifyingImg(null, imgurl, param);
      }
    },
    [handleIdentifyingImg]
  );

  const handleUploadImg = (imgurl) => {
    identifyingImg(null, imgurl, undefined, activeSelectParam);
  };

  const handleSceneSelect = useCallback(() => {
    identifyingImg(1, materialsPath[0], 0, activeSelectParam);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeParam = (value) => {
    setActiveSelectParam(value);
  };

  useEffect(() => {
    handleSceneSelect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (response) {
      setSpinning(false);
    }
  }, [response]);

  return (
    <StyledDemonstration>
      <Spin indicator={antIcon} spinning={spinning}>
        <Row>
          <Col span={16} className="identifying_content">
            <Row style={{ display: 'none' }}>
              <Col span={24} className="identifying_select">
                {selectList.length > 0 ? (
                  <Select
                    defaultValue={activeSelectParam}
                    style={{ width: 120 }}
                    onChange={handleChangeParam}
                  >
                    {selectList.map((opt) => {
                      return (
                        <Option value={opt.key} key={opt.key}>
                          {opt.label}
                        </Option>
                      );
                    })}
                  </Select>
                ) : null}
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <CanvasDrawer
                  id="canvas"
                  backgroundImg={imgDom}
                  width="866"
                  height="524"
                />
              </Col>
              {!noUpload ? (
                <Row className="identifying_upload">
                  <Col span={19} offset={1}>
                    <small>
                      图片文件类型支持PNG、JPG、JPEG、BMP，图片大小不超过2M
                    </small>
                  </Col>
                  <Col span={3}>
                    <UploadImg2base64 onFileReady={handleUploadImg} />
                  </Col>
                </Row>
              ) : null}
            </Row>
            <StyledCenterItem ref={imgRef}>
              {materialsPath.map((materialPath, index) => {
                return (
                  <Col
                    span={6}
                    key={materialPath}
                    className={`identifyingImgBox ${
                      activeSelectIndex === index ? 'activeIndex' : ''
                    }`}
                  >
                    <img
                      src={materialPath}
                      alt="手写体文字识别"
                      onClick={(e) =>
                        identifyingImg(
                          e,
                          materialPath,
                          index,
                          activeSelectParam
                        )
                      }
                      role="presentation"
                    />
                  </Col>
                );
              })}
            </StyledCenterItem>
          </Col>
          <Col span={8} className="identifying_result">
            <Collapse accordion defaultActiveKey="1">
              <Panel header="识别结果" key="1">
                {result}
              </Panel>
              <Panel style={{ display: 'none' }} header="Request" key="2">
                <ReactJson src={request} />
              </Panel>
              <Panel header="Response" key="3">
                <ReactJson src={response} />
              </Panel>
            </Collapse>
          </Col>
        </Row>
      </Spin>
    </StyledDemonstration>
  );
};

FunctionDemonstration.propTypes = {
  request: PropTypes.object,
  response: PropTypes.object,
  result: PropTypes.node,
  materialsPath: PropTypes.array,
  selectList: PropTypes.array,
  handleIdentifyingImg: PropTypes.func,
  noUpload: PropTypes.bool
};

FunctionDemonstration.defaultProps = {
  noUpload: false
};

export default FunctionDemonstration;
